import { EventEmitters } from '@/domain/utils/Events';

enum ModalEvents {
	Reveal = 'reveal',
	Closed = 'closed',
}

type ModalEmitters = EventEmitters<{
	[ModalEvents.Reveal]: (name: string | null) => void;
	[ModalEvents.Closed]: () => void;
}>;

export { ModalEvents, ModalEmitters };
